import { useState } from "react";
import { Link2, Check, Mail, Facebook, Twitter, Linkedin, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { SITE_URL } from "../lib/api";

export default function ShareButtons({ path, title, testid = "share", shareUrl, compact = false }) {
  const url = shareUrl || `${SITE_URL}${path}`;
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Couldn't copy. Select the address bar instead");
    }
  };

  const encUrl = encodeURIComponent(url);
  const encTitle = encodeURIComponent(title);
  const links = [
    { id: "whatsapp", href: `https://wa.me/?text=${encTitle}%20${encUrl}`, Icon: MessageCircle, label: "WhatsApp" },
    { id: "facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${encUrl}`, Icon: Facebook, label: "Facebook" },
    { id: "x", href: `https://twitter.com/intent/tweet?url=${encUrl}&text=${encTitle}`, Icon: Twitter, label: "X" },
    { id: "linkedin", href: `https://www.linkedin.com/sharing/share-offsite/?url=${encUrl}`, Icon: Linkedin, label: "LinkedIn" },
    { id: "email", href: `mailto:?subject=${encTitle}&body=${encUrl}`, Icon: Mail, label: "Email" },
  ];

  const btnCls = compact
    ? "h-8 w-8 inline-flex items-center justify-center border border-zinc-200 bg-zinc-50 rounded-md text-zinc-500 hover:bg-blue-50 hover:border-blue-200 hover:text-blue-700 transition-colors duration-200"
    : "h-9 w-9 inline-flex items-center justify-center border border-zinc-300 rounded-md text-zinc-600 hover:border-zinc-500 hover:text-zinc-950 transition-colors duration-200";

  return (
    <div data-testid={`${testid}-share`}>
      {!compact && <p className="text-xs font-semibold uppercase tracking-wider text-zinc-400 mb-2">Share</p>}
      <div className={`flex flex-nowrap ${compact ? "gap-1.5 justify-center" : "flex-wrap gap-2"}`}>
        <button type="button" onClick={copy} data-testid={`${testid}-share-copy`} aria-label="Copy link"
          className={btnCls}>
          {copied ? <Check className="h-4 w-4 text-green-600" /> : <Link2 className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} />}
        </button>
        {links.map(({ id, href, Icon, label }) => (
          <a key={id} href={href} target="_blank" rel="noopener noreferrer" aria-label={`Share on ${label}`}
            data-testid={`${testid}-share-${id}`}
            className={btnCls}>
            <Icon className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} />
          </a>
        ))}
      </div>
    </div>
  );
}
